// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aCLh","content":"styles_content__3h-xs","tableWrap":"styles_tableWrap__pV7DE"};